import { io, type Socket } from "socket.io-client";

let socket: Socket | null = null;

export function getRealtimeSocket(): Socket {
  if (!socket) {
    const base =
      process.env.REACT_APP_API_ORIGIN?.trim() ||
      (typeof window !== "undefined" ? window.location.origin : "");
    socket = io(base, {
      path: "/socket.io",
      withCredentials: true,
      autoConnect: true,
      transports: ["websocket", "polling"],
    });
  }
  return socket;
}

export function disconnectRealtimeSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
